import { useReviews } from 'hooks/review/useReviews';

import { InfoBlock } from './InfoBlock';
import { Review } from './Review';
import { Title } from './Title';

import s from './ClassicReviewList.module.css';

export const ClassicReviewList = () => {
  const { visibleReviews, hasMoreReviews, showMoreReviews } = useReviews();

  return (
    <InfoBlock id="all-reviews">
      <Title>Ratings & Reviews</Title>
      <div>
        {visibleReviews.map((review) => (
          <Review key={review.id} review={review} />
        ))}
      </div>
      {hasMoreReviews && (
        <div className={s.moreReviewsContainer}>
          <button onClick={showMoreReviews}>Show more reviews</button>
        </div>
      )}
    </InfoBlock>
  );
};
